"use strict";
// packages/types/src/comment.ts
Object.defineProperty(exports, "__esModule", { value: true });
